<div class="rti-carousel" [hidden]="hidden">
  <a class="rti-carousel-control left" href="#" data-toggle="left" (click)="onNav($event)">
    <!-- [class.disabled]="getPageSet()?.indexId < 2" -->
    <mat-icon class="material-icons" aria-label="Left">chevron_left</mat-icon>
    <!-- [class.disabled]="getPageSet()?.indexId < 2" -->
  </a>
  <a class="rti-carousel-control right" href="#" data-toggle="right" (click)="onNav($event)">
    <!-- [class.disabled]="getPageSet()?.indexId >= getPageSet()?.length" -->
    <mat-icon class="material-icons" aria-label="Left">chevron_right</mat-icon>
    <!-- [class.disabled]="getPageSet()?.indexId >= getPageSet()?.length" -->
  </a>
  <section class="rti-carousel-container"
           (swipeleft)="onSwipeLeft($event)"
           (swiperight)="onSwipeRight($event)">
    <div [attr.id]="uid" class="carousel-items is-set" #mycarousel>
      <ng-content></ng-content>
    </div>
  </section>
  <div class="rti-carousel-indicators-content" [hidden]="!indicators">
    <ol class="rti-carousel-indicators">
      <li
        class="rti-carousel-indicator"
        *ngFor="let page of getPages()"
        (click)="onPage(page)"
        [class.active]="page.active"
      ></li>
    </ol>
  </div>
</div>
